import React from "react";

import { SelectList } from "@common/selectList";
import { Props } from "./types";
import { Input } from "./input";
import { Search } from "./search";
import { Zones } from "./zones";
import styles from "./styles.scss";

function ProjectsSelection({ projects, placeholder = "", select }: Props) {
  const [search, setSearch] = React.useState("");

  return (
    <SelectList rootClassName={styles.root} listClassName={styles.list}>
      {({ isOpen, select: s }) => ({
        input: (
          <Input
            placeholder={placeholder}
            projects={projects}
            isOpen={isOpen}
          />
        ),
        list: (
          <div className={styles.projectsSelection}>
            <div className={styles.search}>
              <Search search={search} setSearch={setSearch} />
            </div>
            <Zones
              search={search}
              projects={projects}
              select={(projects) => s(select(projects))}
              isOpen
            />
          </div>
        ),
      })}
    </SelectList>
  );
}

export { ProjectsSelection };
